import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from './Link';

const SubnavLink = ({ label, active, component: Component, className, ...props }) => (
  <Component
    {...props}
    className={cx(
      'lg:text-lg uppercase tracking-wider border-b-2 inline-block py-3 px-5',
      {
        'text-white border-accent': active,
        'text-gray hover:text-white border-transparent': !active,
      },
      className
    )}
  >
    {label}
  </Component>
);

SubnavLink.propTypes = {
  label: PropTypes.node.isRequired,
  active: PropTypes.bool,
  className: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.shape({ render: PropTypes.func }),
  ]),
};

SubnavLink.defaultProps = {
  active: false,
  className: '',
  component: Link,
};

export default SubnavLink;
